import { useAtom } from 'jotai';
import ToggleSwitch from 'components/ui/ToggleSwitch/ToggleSwitch';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import useIsMount from 'utils/useIsMount';
import { useEffect } from 'react';
import { FlexAlignCenter, FlexColAlignStart } from 'components/primitives/flex';
import styled from 'styled-components';
import { exclusiveAtom } from '../filterStore';

export default function ExclusiveFilterSwitch() {
  const [isExclusive, toggleIsExclusive] = useAtom(exclusiveAtom);

  const rudderTrack = useRudderStackTrack();
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      rudderTrack('exclusive_toggle_search', {
        value: isExclusive,
      });
    }
  }, [isExclusive]);

  return (
    <ToggleSwitch
      isActive={isExclusive}
      onChange={() => {
        toggleIsExclusive();
      }}
      onLabel={null}
      offLabel={null}
      icon={null}
      round
      invertColor
    />
  );
}

export const ExclusiveFilterLabel = () => (
  <FlexColAlignStart>
    <FlexAlignCenter>Boatsetter exclusive</FlexAlignCenter>
    <TextWrapper>Only found on Boatsetter</TextWrapper>
  </FlexColAlignStart>
);

const TextWrapper = styled(FlexAlignCenter)`
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;
